/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { DefaultGuardRequest } from './DefaultGuardRequest';

import type { ACTIONS, GuardPolicy, GuardModel, GuardRequest } from './types';

interface GuardSubject {
    [key: string]: unknown;
}

export class Guard {
    public constructor(
        private guardModel: GuardModel,
        private policyList: GuardPolicy[],
        private subject: GuardSubject
    ) {}

    public can = (resourceName: string, action: ACTIONS) => (
        this.guardModel?.effect(
            this.createRequest(resourceName, action),
            this.policyList || []
        ) ?? true
    );

    public createRequest = (resourceName: string, action: ACTIONS): GuardRequest => new DefaultGuardRequest(this.subject, resourceName, action);
}
